import { createAction } from '@reduxjs/toolkit';
import type { BoundaryTerritoryGroup } from '~/store/boundaryTerritoryGroups/boundaryTerritoryGroups.state';

export const dataLayersToolBoundaryTerritoryGroupsCreated = createAction(
  'DATA_LAYERS_TOOL_BOUNDARY_TERRITORY_GROUPS_CREATED',
  (boundaryTerritoryGroups: ReadonlyArray<BoundaryTerritoryGroup>) => ({
    payload: {
      boundaryTerritoryGroups,
    },
  }),
);

export const dataLayersToolUpdateRequest = createAction(
  'DATA_LAYERS_TOOL_UPDATE_REQUEST',
);
